import { api } from "../../api/apollo";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { signOut } from "firebase/auth";
import { firebaseAuth } from "../../index";
import { UserData } from "@services/userService";

export interface AuthState {
  token: string | undefined;
  isLoggedIn: boolean;
  loginErrorMessage: string | undefined;
  user: UserData | undefined;
}

export const initialState: AuthState = {
  token: undefined,
  isLoggedIn: false,
  loginErrorMessage: undefined,
  user: undefined,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    saveToken: (state, { payload }: PayloadAction<string>) => {
      localStorage.setItem("token", payload);
      state.token = payload;
    },
    loginSuccess: (state, { payload }: PayloadAction<string>) => {
      localStorage.setItem("token", payload);
      state.isLoggedIn = true;
      state.loginErrorMessage = undefined;
      state.token = payload;
    },
    loginError: (state, { payload }: PayloadAction<string>) => {
      state.isLoggedIn = false;
      state.loginErrorMessage = payload;
    },
    logout: () => {
      signOut(firebaseAuth).catch(() => {
        console.log("error");
      });
      localStorage.removeItem("token");
      api.client?.resetStore();
      return {
        ...initialState,
      };
    },
    saveUser: (state, { payload }: PayloadAction<UserData>) => {
      state.user = payload;
    },
  },
});

export const { saveToken, loginSuccess, loginError, logout, saveUser } = authSlice.actions;
export const authReducer = authSlice.reducer;
